import { all, fork, put, takeEvery } from 'redux-saga/effects';
import callToAPI from '../../../utils/callToAPI';
import * as Api from '../../api/deliveryNote';
import * as types from './types';

function* getDeliveryNotes({ payload }) {
  yield callToAPI({
    apiCall: Api.listDeliveryNote,
    successResponseCode: 200,
    errorType: types.GET_DELIVERY_NOTES_ERROR,
    *callback({ data: { data, total } }) {
      yield put({
        type: types.GET_DELIVERY_NOTES_SUCCESS,
        payload: {
          data: data,
          total: total,
        },
      });
    },
    payload: {
      ...payload,
      project: payload.pid,
    },
  });
}

function* getDeliveryNote({ payload }) {
  yield callToAPI({
    apiCall: Api.getDeliveryNote,
    successResponseCode: 200,
    errorType: types.GET_DELIVERY_NOTE_ERROR,
    *callback({ data }) {
      yield put({
        type: types.GET_DELIVERY_NOTE_SUCCESS,
        payload: data,
      });
    },
    payload,
  });
}

function* updateDeliveryNote({ payload }) {
  yield callToAPI({
    apiCall: Api.updateDeliveryNote,
    successResponseCode: 200,
    errorType: types.UPDATE_DELIVERY_NOTE_ERROR,
    *callback({ data }) {
      yield payload.callback();
      yield put({
        type: types.UPDATE_DELIVERY_NOTE_SUCCESS,
        payload: data,
      });
    },
    payload: payload.deliveryNote,
  });
}

function* watcherGetDeliveryNotes() {
  yield takeEvery(types.GET_DELIVERY_NOTES_REQUEST, getDeliveryNotes);
}

function* watcherGetDeliveryNote() {
  yield takeEvery(types.GET_DELIVERY_NOTE_REQUEST, getDeliveryNote);
}

function* watcherUpdateDeliveryNote() {
  yield takeEvery(types.UPDATE_DELIVERY_NOTE_REQUEST, updateDeliveryNote);
}

export default function* rootSaga() {
  yield all([
    fork(watcherGetDeliveryNotes),
    fork(watcherGetDeliveryNote),
    fork(watcherUpdateDeliveryNote),
  ]);
}
